document.addEventListener('DOMContentLoaded', function () {
  //Image color chnage gallery
  if (document.querySelectorAll('.product-variant-images .variant-images').length > 0) {
    //input
    if (document.querySelectorAll('.variant-wrapper.js .variant-input input').length > 0) {
      document.querySelectorAll('.variant-wrapper.js .variant-input input').forEach((input) => {
        if (input.checked == true) {
          document.querySelectorAll('.product-variant-images .variant-images').forEach((imgwrap) => {
            if (imgwrap.dataset.value.split('/')[0].trim() == input.value) {
              //imgwrap.style.display = 'flex';
              imgwrap.classList.add('active')
            }
          })
        }

        input.addEventListener('change', function (e) {
          document.querySelectorAll('.product-variant-images .variant-images').forEach((imgwrap) => {
            if (imgwrap.dataset.value.split('/')[0].trim() == e.target.value) {
              document.querySelectorAll('.product-variant-images .variant-images').forEach((imwrpgwrap) => {
                imwrpgwrap.classList.remove('active') /*imwrpgwrap.style.display = 'none'*/
              })

              //imgwrap.style.display = 'flex';
              imgwrap.classList.add('active')
            }
          })
        })
      })
    }
    //select
    if (document.querySelectorAll('.variant-wrapper.js option.variant-input').length > 0) {
      document.querySelectorAll('.variant-input-wrap select').forEach((select) => {
        document.querySelectorAll('.product-variant-images .variant-images').forEach((imgwrap) => {
          if (imgwrap.dataset.value.split('/')[0].trim() == select.value) {
            imgwrap.classList.add('active')
          }
        })

        select.addEventListener('change', function (e) {
          document.querySelectorAll('.product-variant-images .variant-images').forEach((imgwrap) => {
            if (imgwrap.dataset.value.split('/')[0].trim() == this.value) {
              document.querySelectorAll('.product-variant-images .variant-images').forEach((imwrpgwrap) => {
                imwrpgwrap.classList.remove('active') /*imwrpgwrap.style.display = 'none'*/
              })

              imgwrap.classList.add('active')
            }
          })
        })
      })
    }
  } else {
    document.querySelector('.product-gridimages').remove()
  }

  //Variant label name
  //input chnage
  if (document.querySelectorAll('.variant-wrapper.js .variant-input input').length > 0) {
    document.querySelectorAll('.variant-wrapper.js .variant-input input').forEach((input) => {
      if (input.checked == true) {
        input.parentNode.parentNode.parentNode.querySelector('.varian-name-label').innerHTML = input.value
      }
      input.addEventListener('change', function (e) {
        if (e.target.checked) {
          e.target.parentNode.parentNode.parentNode.querySelector('.varian-name-label').innerHTML = e.target.value
        }
      })
    })
  }
  //select chnage
  if (document.querySelectorAll('.variant-wrapper.js option.variant-input').length > 0) {
    document.querySelectorAll('.variant-input-wrap select').forEach((select) => {
      select.parentNode.parentNode.querySelector('.varian-name-label').innerHTML = select.value

      select.addEventListener('change', function (e) {
        this.parentNode.parentNode.querySelector('.varian-name-label').innerHTML = this.value
      })
    })
  }

  //Sizechart move to size picker
  var fragment = document.createDocumentFragment()
  fragment.appendChild(document.querySelector('.size-chart__standalone'))
  document.querySelector('.variant-size').appendChild(fragment)

  //Price and review move im 769 mobile
  function checkScreenSize() {
    if (window.matchMedia('(max-width: 769px)').matches) {
      //price
      var pricemobile = document.createDocumentFragment()
      pricemobile.appendChild(document.querySelector('.product-block.product-block--price'))
      document.querySelector('.mobile-price').appendChild(pricemobile)

      //review stars
      if (document.querySelectorAll('div[data-oke-star-rating]').length > 0) {
        var reviewstars = document.createDocumentFragment()
        reviewstars.appendChild(document.querySelector('div[data-oke-star-rating]'))
        document.querySelector('.mobile-review-stars').appendChild(reviewstars)
      }
    } else {
      //price
      var pricemobile = document.createDocumentFragment()
      pricemobile.appendChild(document.querySelector('.product-block.product-block--price'))
      document.querySelector('.product-price').appendChild(pricemobile)

      //review stars
      if (document.querySelectorAll('div[data-oke-star-rating]').length > 0) {
        var reviewstars = document.createDocumentFragment()
        reviewstars.appendChild(document.querySelector('div[data-oke-star-rating]'))
        document.querySelector('div[data-product-blocks] .shopify-app-block:nth-child(1)').appendChild(reviewstars)
      }
    }
  }
  checkScreenSize()
  window.addEventListener('resize', checkScreenSize)
})

// jQuery
;(function ($) {
  //Product image popup
  $('.js-zoom-image').magnificPopup({
    type: 'image',
    tLoading: 'Loading image #%curr%...',
    mainClass: 'mfp-img-mobile',
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
    },
    image: {},
    callbacks: {
      resize: function () {
        let heightLoadImg = this.content.find('img').height()
        this.content.find('img').addClass('smallSize')
        this.content.find('img').on('click', function () {
          if ($(this).hasClass('smallSize')) {
            $(this).css('max-height', '100%')
            $(this).removeClass('smallSize')
          } else {
            $(this).css('max-height', heightLoadImg)
            $(this).addClass('smallSize')
          }
        })
      },
      imageLoadComplete: function () {
        this.content.find('img').css('width', 'auto')
      },
      change: function () {
        this.content.find('img').css('max-width', 'auto')
      },
    },
  })
  //Product gallery popup
  $('.js-zoom-gallery').magnificPopup({
    type: 'image',
    fixedContentPos: false,
    fixedBgPos: true,

    overflowY: 'auto',
    removalDelay: 300, //delay removal by X to allow out-animation
    callbacks: {
      beforeOpen: function () {
        // just a hack that adds mfp-anim class to markup
        this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim')
        this.st.mainClass = 'mfp-zoom-in'
        setTimeout(function () {
          document.querySelector('.mfp-arrow-left').innerHTML = `
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gall-nav-icon icon-chleft"><title>Left</title><polyline points="15 18 9 12 15 6"></polyline></svg>
                `
          document.querySelector('.mfp-arrow-right').innerHTML = `
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="gall-nav-icon icon-chright"><title>Right</title><polyline points="9 18 15 12 9 6"></polyline></svg>
                `
        }, 10)
      },
      change: function () {},
    },
    closeBtnInside: true,
    preloader: false,

    midClick: true,
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1],
    },
  })
  //replace gallery nav icons
})(jQuery) //jQuery*/



document.addEventListener('DOMContentLoaded', () => {
  //Custom Select change
  function selectCustomFormInputs() {
      const falseSelectLabels = document.querySelectorAll('.js-false-select-label');

      if (falseSelectLabels.length > 0) {
          function handleFalseSelectLabelClick(event) {
              falseSelectLabels.forEach(falseSelectLabel => {
                  const parentElement = falseSelectLabel.parentElement;
                  if (event.target === falseSelectLabel) {
                      parentElement.classList.toggle('active');
                  } else if (!parentElement.contains(event.target)) {
                      parentElement.classList.remove('active');
                  }
              });
          }

          document.removeEventListener('click', handleFalseSelectLabelClick);
          document.addEventListener('click', handleFalseSelectLabelClick);

          function updateFalseSelectLabels() {
              falseSelectLabels.forEach(falseSelectLabel => {
                  const radioInputs = falseSelectLabel.closest('.inner-radio-variants-container').querySelectorAll('.inner-radio-variants input');
                  
                  radioInputs.forEach(input => {
                      if (input.checked) {
                          falseSelectLabel.textContent = input.value;
                      }
                  });

                  radioInputs.forEach(input => {
                      input.addEventListener('change', () => {
                          if (input.checked) {
                              falseSelectLabel.textContent = input.value;
                          }
                      });
                  });
              });
          }

          updateFalseSelectLabels();
      }
  }

  selectCustomFormInputs();
});

